// extracted by mini-css-extract-plugin
module.exports = {"container":"container__3e9xd","body":"body__24t72","icon":"icon__1t8hd","title":"title__2HVLI","bgImage":"bgImage__2V4NN"};